import { createReducer, on } from '@ngrx/store';
import { clearLocationInt, saveLocationInt } from './international.actions';

export const saveLocationIntReducer = (
    _: any,
    { value }: { value: any },
): any => value;

export const clearLocationIntReducer = () => {
    return {};
};

export const LocationIntReducer = createReducer(
    {},
    on(saveLocationInt, saveLocationIntReducer),
    on(clearLocationInt, clearLocationIntReducer),
);
